export enum InitiativeStatus {
	New = 1,
	Ready = 2,
	InProgress = 3,
	Finished = 4,
	Testing = 5
}
